// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2FmyN","icon":"SortAdornment_icon__XEBT-","up":"SortAdornment_up__4rV6Z","down":"SortAdornment_down__1GM7I","active":"SortAdornment_active__1o2qT"};